export const iconFontAwesomeArrowsArrowsLeftRightToLine = (
	<i className="fa-solid fa-arrows-left-right-to-line"></i>
);
